export class SolPageState {
  private constructor() {}

  public static of(): SolPageState {
    return new SolPageState();
  }
}
